/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getTags, getTag, printTag, createTags, updateTags, deleteTags } from "Modules/tags/config/api.tags";

const state = {
    page: {},
    form: {},
    tags: [],
    tag_options: [],
    selectedTag: {
        tag_id: null,
        company_id: "",
        tag_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        tag_details: [],
    },
    tags_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        company_id: "",
    },
    rules_tags: {
        tag: {
            name: "tag",
            rules: "trim|max_length[65]|required",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    tags: (state) => {
        return state.tags;
    },
};

// actions
const actions = {
    async fetchTags({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getTags({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "tag_options",
                        with: response.data.tags,
                    });
                } else {
                    commit("mutate", {
                        property: "tags",
                        with: response.data.tags,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchTag({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getTag(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedTag",
                    with: response.data.tag,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printTag({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printTag(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveTag({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["tag_id"] === "undefined" || body["tag_id"] == null || body["tag_id"] == "") {
                delete body["tag_id"];
                response = await createTags({ body: body, headers: config.headers });
            } else {
                let tag_id = body["tag_id"];
                delete body["tag_id"];
                response = await updateTags({ body: body, headers: config.headers }, tag_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteTag({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteTags(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    updateTagOptions(state, payload) {
        state.tag_options = payload;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
